import { render, staticRenderFns } from "./PlanRead1.vue?vue&type=template&id=1a60b316&scoped=true"
import script from "./PlanRead1.vue?vue&type=script&lang=js"
export * from "./PlanRead1.vue?vue&type=script&lang=js"
import style0 from "./PlanRead1.vue?vue&type=style&index=0&id=1a60b316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60b316",
  null
  
)

export default component.exports